<template>
  <RF-Dialog v-if="cpntSilencioso === false && mapa.length >= 1"
    :cpntStatus='statusGeral'
    :cpntLargura='"750px"'
    :cpntTitulo="cpntTitulo"
    :cpntOnFecharDialog='cpntBuscarCadastroFechar'>
    <template slot='conteudo'>
      <div class="cpnt-buscar-cadastro-api">
        <App-Tabela
        :cpntColuna="colunas"
        :cpntLinha="mapa"
        :cpntMostrarMper="false"
        ref="tabela">
          <!-- <template v-slot:col_valor_atual="{ linha }">
            <span v-html="cpntBuscarValor(linha.chave, 'atual', dados)"></span>
          </template> -->

          <template v-slot:col_acao="{ indexL, valor }">
            <App-Toggles-2
              :cpntStatus='valor.status'
              :cpntId='valor.id'
              :cpntClassDivField='valor.classDivField'
              :cpntNome='valor.nome'
              :cpntValue='valor.value'
              :cpntDisabled='valor.disabled'
              :cpntMostrar='valor.mostrar'
              :cpntMensagem='valor.mensagem'
              :cpntMensagemTipo='valor.mensagemTipo'
              :cpntOptions='valor.options'
              :cpntKeyValue='valor.keyValue'
              :cpntKeyMostra='valor.keyMostra'
              :cpntExplica='valor.explica'
              :cpntTabIndex='valor.tabIndex'

              :cpntOnChange='(value) => { cpntBuscarCadastroOnChange(value, indexL, "acao") }'
              :cpntOnBlur='valor.onBlur'
              :ref='valor.tipo'
            ></App-Toggles-2>
          </template>
        </App-Tabela>
      </div>
    </template>

    <template slot='rodape'>
      <div class="cpnt-buscar-cadastro-api-rodape">
        <RF-Button
          :cpntStatus='botoes.cancelar.status' 
          :cpntId='botoes.cancelar.id' 
          :cpntTexto='botoes.cancelar.texto' 
          :cpntClass='botoes.cancelar.class'
          :cpntMostrar='botoes.salvar.mostrar'
          :cpntTabIndex='botoes.cancelar.tabIndex'
          @onClickButton='botoes.cancelar.onClick'
        ></RF-Button>

        <RF-Button
          :cpntStatus='botoes.salvar.status' 
          :cpntId='botoes.salvar.id' 
          :cpntTexto='botoes.salvar.texto' 
          :cpntClass='botoes.salvar.class'
          :cpntMostrar='botoes.salvar.mostrar'
          :cpntTabIndex='botoes.salvar.tabIndex'
          @onClickButton='botoes.salvar.onClick'
        ></RF-Button>
      </div>
    </template>
  </RF-Dialog>
</template>

<style scoped>
  .cpnt-buscar-cadastro-api {
    width: 100%;
  }
  .cpnt-buscar-cadastro-api-rodape {
    text-align: right;
  }
    .cpnt-buscar-cadastro-api-rodape > button:not(:first-child) {
      margin-left: 5px;
    }
</style>

<style>
.cpnt-buscar-cadastro-api > table {
  width: 100%;
}
.cpnt-buscar-cadastro-api > table > tbody > tr > td.col_campo {
  width: 100px;
}
.cpnt-buscar-cadastro-api > table > tbody > tr > td.col_acao {
  padding: 5px 0px;
  width: 230px;
}
.cpnt-buscar-cadastro-api > table > tbody > tr > td.col_valor_atual,
.cpnt-buscar-cadastro-api > table > tbody > tr > td.col_valor_novo {
  width: 205px;
  min-width: 205px;
  max-width: 205px;
}
</style>

<script>
  export default {
    props: {
      cpntTitulo: {
        required: false,
        type: String,
        default: function () {
          return 'Buscar cadastro'
        }
      },
      cpntMapa: {
        required: true,
        type: Array
      },
      cpntRouter: {
        required: true,
        type: String
      },
      cpntMethod: {
        required: true,
        type: String
      },
      cpntSilencioso: {
        required: false,
        type: Boolean,
        default: function () {
          return false
        }
      },
      cpntParams: {
        required: true
      },
      cpntBuscaSilenciosa: {
        required: false,
        type: Boolean,
        default: function () {
          return false
        }
      },
      cpntBuscarValor: {
        required: true,
        type: Function
      },
      cpntSetarValor: {
        required: true,
        type: Function
      },
      cpntBuscaComplementar: {
        required: false,
        default: function () {
          return null
        }
      },
      cpntFecharFormulario: {
        required: true
      }
    },
    data: function () {
      return {
        time: '',
        statusGeral: 'carregando',
        colunas: [
          { mPer: 1, chave: 'campo', nome: 'Campo' },
          { mPer: 1, chave: 'valor_atual', nome: 'Valor atual' },
          { mPer: 1, chave: 'acao', nome: 'Ação' },
          { mPer: 1, chave: 'valor_novo', nome: 'Valor novo' },
        ],
        dados: {},
        mapa: [],
        botoes: {
          cancelar: {
            status: '',
            texto: 'Cancelar',
            class: [ 'btn', 'btn-default', 'btn-sm' ],
            mostrar: true,
            onClick: () => { this.cpntBuscarCadastroFechar(false) }
          },
          salvar: {
            status: '',
            texto: 'Copiar',
            class: [ 'btn', 'btn-primary' ],
            mostrar: true,
            onClick: () => { this.cpntBuscarCadastroSalvar() }
          },
        }
      }
    },
    mounted: function () {
      this.cpntBuscarCadastroIniciar()
    },
    methods: {
      cpntBuscarCadastroIniciar: function () {
        // SETA O STATUS DA TELA
        this.cpntBuscarCadastroSetarStatusGeral('carregando')

        // FAZ A BUSCA DOS DADOS SOLICITADOS
        this.cpntBuscarCadastroCarregarDados((vetor) => {
          this.cpntBuscarCadastroComplementar(vetor, (dados) => {
            // SETA OS DADOS RECEBIDOS
            this.dados = dados
  
            // CHAMA A FUNÇÃO PARA ATUALIZAR O MAPA E DEPOIS FINALIZAR
            this.cpntBuscarCadastroAtualizarMapa(() => {
              // SETA O STATUS DA TELA
              this.cpntBuscarCadastroSetarStatusGeral('')

              // VERIFICA SE ESTÁ NO MODO SILECIOSO DE BUSCA
              if (this.cpntSilencioso === true) {
                this.cpntBuscarCadastroSalvar()
              }
            })
          })
        })
      },
      cpntBuscarCadastroComplementar: function (dados, callback) {
        if ([ '', null, undefined ].indexOf(this.cpntBuscaComplementar) === -1) {
          this.cpntBuscaComplementar(dados, callback)
        } else {
          callback(dados)
        }
      },
      cpntBuscarCadastroFechar: function (atualizar = false, dados = {}) {
        this.cpntFecharFormulario(atualizar, dados)
      },
      cpntBuscarCadastroSetarStatusGeral: function (status) {
        // SETA O STATUS DA TELA
        this.statusGeral = status

        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        this.time = new Date().getTime()
      },
      cpntBuscarCadastroCarregarDados: function (callback = null) {
        this.$store.state.comunicaAPI(this.cpntRouter, this.cpntMethod, this.cpntParams, (retorno) => {
          if ([ '', null, undefined ].indexOf(retorno.lot) === -1) {
            // PEGA O VALOR RECEIBOD
            retorno = retorno.lot[0]

            // VERIFICA SE DEU ALGUM ERRO NO PROCESSO
            if (retorno.code !== '200') {
              // APRESENTA A MENSAGEM DE SUCESSO
              this.$store.state.TRATAR_RET_LOT_API(retorno)

              // FECHA A JANELA ABERTA
              this.cpntBuscarCadastroFechar()
            } else {
              callback(retorno.data)
            }
          }
        }, this.cpntBuscarCadastroSetarStatusGeral)
      },
      cpntBuscarCadastroAtualizarMapa: function (callback = null) {
        // INICIA A VARIAVEL
        var mapa = []
        
        // INICIA A VARIAVEL DE CONFERENCIA
        var conferido = []

        // TRATA CADA LINHA DE COMPARAÇÃO
        for (var indexM in this.cpntMapa) {
          // SETA O NOME DO CAMPO A SER TRABALHADO
          var item = { campo: this.cpntMapa[indexM].nome, chave: this.cpntMapa[indexM].chave }

          // SETA OS DADOS DO TOGGLES
          item.acao = {
            value: '2',
            options: [
              { id: '0', nome: 'Manter', disabled: (this.cpntMapa[indexM].acoes.indexOf('manter') === -1) },
              { id: '1', nome: 'Mesclar', disabled: (this.cpntMapa[indexM].acoes.indexOf('mesclar') === -1) },
              { id: '2', nome: 'Substituir', disabled: (this.cpntMapa[indexM].acoes.indexOf('substituir') === -1) }
            ],
            keyValue: 'id',
            keyMostra: [ 'nome' ],
            mostrar: true
          }

          // BUSCA O VALOR DO CAMPO ATUAL
          item.valor_atual = this.cpntBuscarValor(this.cpntMapa[indexM].chave, 'atual', this.dados)

          // BUSCA O VALOR DO NOVO CAMPO
          item.valor_novo = this.cpntBuscarValor(this.cpntMapa[indexM].chave, 'novo', this.dados)

          // ADICIONA A LINHA AO VETOR
          if (item.valor_atual !== item.valor_novo) {
            // ADICIONA O CAMPO PARA ATUALIZAÇÃO
            mapa.push(item)

            // COLOCA O CAMPO COMO CONFERIDO, POIS O VALOR INICIAL ESTÁ EM BRANCO
            if ([ '', null, undefined ].indexOf(item.valor_atual) !== -1) {
              conferido.push(this.cpntMapa[indexM].chave)
            }
          } else {
            conferido.push(this.cpntMapa[indexM].chave)
          }
        }

        // SETA O MAPA NO COMPONENT
        this.mapa = mapa

        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        this.time = new Date().getTime()

        // EXECUTA O CALLABACK RECEBIDO
        if (conferido.length === 0 && this.cpntMapa.length >= 1 && mapa.length === 0) {
          // APRESENTA A MESNAGEM AO CLIENTE
          this.$store.state.msgWarn('Todos os dados solicitados já estão preenchidos no formulário. Nenhuma alteração encontrada.', 'warning')

          // CHAMA A FUNÇÃO PARA FECHAR O FORMULARIO
          this.cpntBuscarCadastroFechar()
        } else if (this.cpntMapa.length === conferido.length) {
          this.cpntBuscarCadastroSalvar()
        } else if (callback !== null && typeof callback === 'function') {
          callback()
        }
      },
      cpntBuscarCadastroOnChange: function (value, indexL, campo) {
        // SETA O VALOR RECEBIDO
        this.$set(this.mapa[indexL][campo], 'value', value)

        // LIMPA O CAMPO DE MENSAGEM DE ERRO
        this.$set(this.mapa[indexL][campo], 'mensagem', '')

        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        this.time = new Date().getTime()
      },
      cpntBuscarCadastroSalvar: function () {
        // SETA O STATUS DO BOTÃO
        this.botoes.salvar.status = 'carregando'

        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        this.time = new Date().getTime()

        // FAZ O PROCESSAMENTO DE CADA LINHA
        for (var index in this.mapa) {
          // PEGA A AÇÃO ESCOLHIDA PELO USUARIO
          var acao = this.mapa[index].acao.options.filter(item => item.id === this.mapa[index].acao.value)[0]

          // CHAMA A FUNÇÃO PARA SETAR O VALOR RECEBIDO
          this.cpntSetarValor(this.mapa[index].chave, acao, this.dados)
        }

        // APRESENTA A MENSAGEM DE SUCESSO
        if (this.cpntSilencioso !== true) {
          this.$store.state.msgWarn('WEB [200]: A solicitação foi processada com sucesso.', 'danger')
        }

        // CHAMA A FUNÇÃO PARA FECHAR O FORMULARIO
        this.cpntBuscarCadastroFechar(true)
      }
    },
    watch: {
      cpntMapa: function () {
        this.cpntBuscarCadastroAtualizarMapa()
      }
    }
  }
</script>
